export default __webpack_public_path__ + "ec1d038a7299a1b9744ff233283db0ad.png";